import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  FaBars,
  FaTachometerAlt,
  FaFolderOpen,
  FaTasks,
  FaUser,
  FaBell,
  FaChartBar,
  FaSearch,
  FaUsersCog,
} from "react-icons/fa";
import "../../utils/echo";
import "./Sidebar.css";
import { useNotification } from "../Notifications/NotificationContext";

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  // const [unreadCount, setUnreadCount] = useState(0);

  const token = localStorage.getItem("auth_token");
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.id;

  const { unreadCount, setUnreadCount } = useNotification();

  useEffect(() => {
    const fetchUnreadCount = async () => {
      const res = await fetch(
        "https://loopsneller.com/api/notifications/unread-count",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.ok) {
        const data = await res.json();
        setUnreadCount(data.unread); // ✅ fixed this line
      }
    };

    fetchUnreadCount();

    if (userId) {
      window.Echo.private(`notifications.${userId}`).listen(
        ".new-notification",
        (event) => {
          setUnreadCount((prev) => prev + 1); // ✅ fixed this line
        }
      );
    }

    return () => {
      if (userId) {
        window.Echo.leaveChannel(`private-notifications.${userId}`);
      }
    };
  }, [userId, token]);

  const links = [
    { path: "/dashboard", label: "Dashboard", icon: <FaTachometerAlt /> },
    { path: "/projects", label: "Projects", icon: <FaFolderOpen /> },
    { path: "/tasks", label: "Tasks", icon: <FaTasks /> },
    {
      path: "/notifications",
      label: `Notifications ${unreadCount > 0 ? `(${unreadCount})` : ""}`,
      icon: <FaBell />,
    },
    { path: "/reports", label: "Reports", icon: <FaChartBar /> },
    // { path: "/search", label: "Search", icon: <FaSearch /> },
    // { path: "/profile", label: "Profile", icon: <FaUser /> },
    ...(user?.role === "Admin"
      ? [
          {
            path: "/admin/users",
            label: "User Management",
            icon: <FaUsersCog />,
          },
        ]
      : []),
  ];

  return (
    <div
      className={`sidebar bg-dark text-white d-flex flex-column p-3 ${
        collapsed ? "collapsed" : ""
      }`}
    >
      <button
        className="btn btn-outline-light mb-3"
        onClick={() => setCollapsed(!collapsed)}
      >
        <FaBars />
      </button>

      <ul className="nav flex-column">
        {links.map((item) => (
          <li className="nav-item" key={item.path}>
            <Link to={item.path} className="nav-link sidebar-link">
              <span className="sidebar-icon">{item.icon}</span>
              <span className="sidebar-label ms-2">{item.label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
